import { log } from 'log';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { validateGeolocation } from 'js/hooks/auth/pas';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import { showGeoComplyPopupAction } from '../actions';
import * as constants from '../constants';

export const useReceivePacket = ({
    triggerGeolocation,
    setShowOverlay,
    useTransparentPopup,
    triggerTimestampRef
}) => {
    const dispatch = useDispatch();

    return useCallback(async (geoPacket, geolocationType, transactionID) => {
        const time = Date.now() - (triggerTimestampRef.current ?? 0);

        publicEventsAPIService.trigger('geofencing-response', { transactionID, time });

        log('gcRes', { transactionID, geoPacket });

        try {
            const response = await validateGeolocation(null, null, geoPacket, transactionID, null, geolocationType);

            if (response.data.errorCode === 0) {
                // all good
                setShowOverlay(false);
            }
        } catch (response) {
            publicEventsAPIService.trigger('geofencing-error', { response });

            switch (response.data.errorCode) {
                case 109:
                    // do nothing here, just try again
                    break;
                case 105:
                    // location is not allowed
                    setShowOverlay(false);
                    dispatch(showGeoComplyPopupAction({
                        title: 'playtech.mobile.system.geocomply.popups.notAllowed.title',
                        content: response.data.playerMessage,
                        isModal: true,
                        useTransparentPopup
                    }));

                    // do not continue with geolocation
                    return;
                default:
                // noop
            }
        }

        await triggerGeolocation({
            reason: constants.GEOLOCATION_REASON.INTERVAL_CHECK
        });
    }, [
        dispatch,
        triggerGeolocation,
        setShowOverlay,
        useTransparentPopup,
        triggerTimestampRef
    ]);
};
